import React, { useEffect, useRef } from 'react';
import { useTranslationContext } from '../../context/TranslationContext';
export var Modal = function (props) {
    var children = props.children, onClose = props.onClose, open = props.open;
    var t = useTranslationContext('Modal').t;
    var innerRef = useRef(null);
    var closeRef = useRef(null);
    var handleClick = function (event) {
        var target = event.target;
        if (!innerRef.current || !closeRef.current)
            return;
        if (!innerRef.current.contains(target) || closeRef.current.contains(target))
            onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    useEffect(function () {
        if (!open)
            return;
        var handleEscKey = function (event) {
            if (event.key === 'Escape')
                onClose === null || onClose === void 0 ? void 0 : onClose();
        };
        document.addEventListener('keydown', handleEscKey);
        return function () { return document.removeEventListener('keydown', handleEscKey); };
    }, [onClose, open]);
    var openClasses = open ? 'str-chat__modal--open' : 'str-chat__modal--closed';
    if (!open)
        return null;
    return (React.createElement("div", { className: "str-chat__modal " + openClasses, onClick: handleClick },
        React.createElement("button", { className: 'str-chat__modal__close-button', ref: closeRef, title: 'Close' },
            t('Close'),
            React.createElement("svg", { height: '10', width: '10', xmlns: 'http://www.w3.org/2000/svg' },
                React.createElement("path", { d: 'M9.916 1.027L8.973.084 5 4.058 1.027.084l-.943.943L4.058 5 .084 8.973l.943.943L5 5.942l3.973 3.974.943-.943L5.942 5z', fillRule: 'evenodd' }))),
        React.createElement("div", { className: 'str-chat__modal__inner', ref: innerRef }, children)));
};
